/* eslint-disable no-multi-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, ReactNode, useMemo } from 'react'
import { IListItem, IImgRL } from './interface'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import applyHttpsImage from 'lib/apply-https-img'
import Link from 'next/link'
import { useRouter } from 'next/router'
import noopWrapper from 'lib/noop-wrapper'
import { count } from 'Pages/auto/images/detail/home'

const abbrImgWidth = 138
const mainImgWidth = 1068
const innerWidth = 968

const transitionSpeed = 0.3

const Arrows = ({
  index,
  max,
  seriesId,
  category,
  carId,
  color,
}: {
  isHover: boolean
  setHover: (b: boolean) => void
  onClickLeft?: (index: number) => void
  onClickRight?: (index: number) => void
  index: number
  max: number
  carId: number | ''
  seriesId: string
  category: string
  color: string
}) => {
  return (
    <>
      {index > 0 && (
        <Link
          href={`/auto/images/detail`}
          as={`/series-${seriesId}/images/${category || 'x'}-${carId || 'x'}-${
            color || 'x'
          }-${index - 1 || 'x'}`}
        >
          <a>
            <i className={`icon-left icon-next-arrow arrow-left arrow`} />
          </a>
        </Link>
      )}
      {index < max - 1 && (
        <Link
          href={`/auto/images/detail`}
          as={`/series-${seriesId}/images/${category || 'x'}-${carId || 'x'}-${
            color || 'x'
          }-${index + 1}`}
        >
          <a>
            <i className={`icon-right icon-next-arrow arrow`} />
          </a>
        </Link>
      )}

      <style jsx>
        {`
          .arrow {
            font-size: 38px;
            color: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            transition: opacity 0.1s;
            width: 100px;
            height: 100px;
            border-radius: 50px;
            opacity: 0;
            background-color: rgba(255, 255, 255, 0.4);
          }

          .arrow-left::before {
            transform: rotate(180deg);
          }
          .icon {
            font-size: 32px;
            color: #909090;
          }
          .icon-left {
            left: 20px;
          }
          .icon-right {
            right: 20px;
          }
          i {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            cursor: pointer;
          }
        `}
      </style>
    </>
  )
}

const ImageRidingLantern: React.FC<
  IImgRL & {
    imgAltName?: string
  }
> = (props) => {
  const { data, initIndex, category, color, seriesId, carId, imgAltName } =
    props
  const offset = data?.paging?.offset || 0

  const abbrRef = useRef<HTMLDivElement>(null)
  const mainRef = useRef<HTMLDivElement>(null)

  const [isHover, setHover] = useState(false)

  const [prevData, setPrevData] = useState(data?.list)

  const speed = useMemo(() => {
    return prevData === data?.list ? transitionSpeed : 0
  }, [prevData, data?.list])

  useEffect(() => {
    if (speed === 0) {
      setPrevData(data?.list)
    }
  }, [speed])

  const footTranslate = useMemo(() => {
    return Math.max(
      Math.min(0, -((initIndex % count) - 3) * abbrImgWidth),
      innerWidth - (data?.list?.length || 0) * abbrImgWidth
    )
  }, [initIndex, data?.list])

  const [footOffset, setFootOffset] = useState(0)

  const moveAbbrBy = (direct: string) => {
    if (direct === 'next') {
      const min = innerWidth - (data?.list?.length || 0) * abbrImgWidth
      if (footTranslate + footOffset === min) {
        return
      }
      setFootOffset((prev) =>
        Math.max(prev - 3 * abbrImgWidth, min - footTranslate)
      )
    } else {
      if (footTranslate + footOffset === 0) {
        return
      }
      setFootOffset((prev) => Math.min(prev + 3 * abbrImgWidth, -footTranslate))
    }
  }

  useEffect(() => {
    setFootOffset(0)
  }, [initIndex])

  const [loadStatus, setLoadStatus] = useState(0) // 0 加载中； 1 成功； 2 失败

  const router = useRouter()

  useEffect(() => {
    /* 绑定按键图片左右翻页 */
    const handleKeyPress = (e: any) => {
      if (e.keyCode === 39) {
        // 需要添加条件使用，否则页面其他输入框无法输入
        e.preventDefault()
        if (initIndex < (data?.paging?.total_count || 0)) {
          router.push(
            '/auto/images/detail',
            `/series-${seriesId}/images/${category || 'x'}-${carId || 'x'}-${
              color || 'x'
            }-${initIndex + 1 || 'x'}`
          )
        }
      }
      if (e.keyCode === 37) {
        // 需要添加条件使用，否则页面其他输入框无法输入
        e.preventDefault()
        if (initIndex > 0) {
          router.push(
            '/auto/images/detail',
            `/series-${seriesId}/images/${category || 'x'}-${carId || 'x'}-${
              color || 'x'
            }-${initIndex - 1 || 'x'}`
          )
        }
      }
    }

    /* 绑定按键图片左右翻页 */
    window.addEventListener('keydown', handleKeyPress, false)
    return () => {
      window.removeEventListener('keydown', handleKeyPress, false)
    }
  }, [initIndex, data?.paging?.total_count, category, carId, color, router])

  return (
    <div>
      <div className="image-list">
        <div className="img-container" ref={mainRef}>
          {data?.list?.length > 0
            ? data.list.map(
              ({ info: { toutiaourl, car_name, color_name } }: IListItem) => (
                <img
                  onError={() => {
                    setLoadStatus(2)
                  }}
                  key={toutiaourl}
                  src={applyHttpsImage(
                    toutiaourl &&
                        toutiaourl.replace(
                          'tplv-resize:1024:0',
                          'tplv-resize:2048:0'
                        )
                  )}
                  alt={imgAltName}
                />
              )
            )
            : null}
        </div>
        {data?.list?.length === 0 ? (
          <div className="no-image">
            {loadStatus === 0 ? '加载中' : '暂无图片'}
          </div>
        ) : null}
        <Arrows
          isHover={isHover}
          setHover={setHover}
          index={initIndex}
          max={data?.paging?.total_count || 0}
          seriesId={seriesId}
          carId={carId}
          color={color}
          category={category}
        />
      </div>
      {data?.list?.length > 0 ? (
        <div className="wheel-plant">
          {((data?.paging?.offset || 0) && footTranslate + footOffset === 0
            ? (content: ReactNode) => (
              <Link
                href={`/auto/images/detail`}
                as={`/series-${seriesId}/images/${category || 'x'}-${
                  carId || 'x'
                }-${color || 'x'}-${
                  (data?.paging?.offset || 0) - count || 'x'
                }`}
              >
                <a>{content}</a>
              </Link>
            )
            : noopWrapper)(
            <i
              className="icon-left icon-next-arrow-s arrow-left icon"
              onClick={() => {
                sendTeaCommEvent('click_series_picture_detail_flip_over', {
                  car_series_id: seriesId,
                  car_style_id: carId,
                  current_pic_rank: initIndex - 3,
                  obj_text: '左翻',
                  sub_tab: category,
                  body_color: color,
                })
                moveAbbrBy('prev')
              }}
            />
          )}
          <div>
            <div ref={abbrRef}>
              {data?.list?.map(
                (
                  { info: { toutiaourl, car_name, color_name } }: IListItem,
                  index: number
                ) => (
                  <Link
                    href={`/auto/images/detail`}
                    as={`/series-${seriesId}/images/${category || 'x'}-${
                      carId || 'x'
                    }-${color || 'x'}-${offset + index || 'x'}`}
                    key={toutiaourl}
                    scroll={false}
                  >
                    <a
                      onClick={(e) => {
                        sendTeaCommEvent('click_series_mini_picture_index', {
                          car_series_id: seriesId,
                          car_style_id: carId,
                          current_pic_rank: index,
                          sub_tab: category,
                          body_color: color,
                        })
                      }}
                    >
                      <img
                        style={{
                          border:
                            index === initIndex % 30 ? 'solid 4px #ffe100' : '',
                          width: 136,
                          height: 90,
                        }}
                        src={toutiaourl}
                        alt={imgAltName}
                      />
                    </a>
                  </Link>
                )
              )}
            </div>
          </div>
          {((data?.paging?.offset || 0) + count <
            (data?.paging?.total_count || 0) &&
            footTranslate + footOffset ===
              innerWidth - (data?.list?.length || 0) * abbrImgWidth
            ? (content: ReactNode) => (
              <Link
                href={`/auto/images/detail`}
                as={`/series-${seriesId}/images/${category || 'x'}-${
                  carId || 'x'
                }-${color || 'x'}-${(data?.paging?.offset || 0) + count}`}
              >
                <a>{content}</a>
              </Link>
            )
            : noopWrapper)(
            <i
              className="icon-right icon-next-arrow-s icon"
              onClick={() => {
                sendTeaCommEvent('click_series_picture_detail_flip_over', {
                  car_series_id: seriesId,
                  car_style_id: carId,
                  current_pic_rank: initIndex + 3,
                  obj_text: '右翻',
                  sub_tab: category,
                  body_color: color,
                })
                moveAbbrBy('next')
              }}
            />
          )}
        </div>
      ) : null}

      <style jsx>
        {`
          div {
            transition: all ${speed}s;
          }
          .img-container {
            white-space: nowrap;
            transform: translateX(${-(initIndex % count) * mainImgWidth}px);
          }
          .img-container img {
            object-fit: contain;
          }
          .no-image {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 715px;
            background-color: #3a3a3a;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 28px;
            color: #999999;
          }
          img,
          .image-list {
            position: relative;
            width: ${mainImgWidth}px;
            height: 715px;
            line-height: 0;
          }
          img {
            display: inline-block;
          }
          .image-list {
            position: relative;
            overflow: hidden;
          }

          .image-list:hover :global(.arrow) {
            opacity: 1 !important;
          }

          .arrow-left::before {
            transform: rotate(180deg);
          }
          .icon {
            font-size: 32px;
            color: #909090;
          }

          i {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            cursor: pointer;
          }
          .wheel-plant {
            display: flex;
            justify-content: space-between;
            width: ${mainImgWidth}px;
            height: 90px;
            margin-top: 2px;
            user-select: none;
          }
          .wheel-plant i {
            width: 50px;
            height: 90px;
            background-color: rgba(255, 255, 255, 0.2);
          }
          .wheel-plant i:hover {
            background-color: rgba(255, 255, 255, 0.4);
          }
          .wheel-plant > div {
            flex: 1;
            width: 100%;
            position: relative;
            overflow: hidden;
            white-space: nowrap;
          }
          .wheel-plant > div > div {
            transform: translateX(${footTranslate + footOffset}px);
          }
          .wheel-plant a {
            display: inline-block;
          }
          .wheel-plant img {
            display: inline-block;
            width: ${abbrImgWidth}px;
            height: 90px;
            margin: 0 1px;
            object-fit: cover;
            object-position: center;
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
}

export default ImageRidingLantern
